import { useGetOrgListMutation } from "store/api/fourvenues";
import { fixedCacheKeys } from "utils/fixedCacheKeys";

export const useFourvenuesHook = () => {
  const [
    getOrgList,
    { data: orgListData, isLoading: isOrgListLoading, reset: resetOrgList },
  ] = useGetOrgListMutation({
    fixedCacheKey: fixedCacheKeys.FOURVENUES_ORG_LIST,
  });

  return {
    getOrgList,
    orgListData,
    isOrgListLoading,
    resetOrgList,
  };
};
